import api from '../../../services/Api';
import { IAuditoriaProvisaoEspelhoResultado } from '../interfaces/IAuditoriaProvisaoEspelho';

export const AuditoriaProvisaoEspelhoService = {
  buscarResultado: async (params: { empresaId: number; periodo: string | undefined })
    : Promise<IAuditoriaProvisaoEspelhoResultado> => {
    const response = await api.get<IAuditoriaProvisaoEspelhoResultado>(
      'auditoria-provisao-espelho/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
